import type {CodeListMap, Schema} from 'schemaDefinition/types';
import {useSchemaDataAccess} from '../contexts';
import {useSchemaListCodelistIds} from './useSchemaListCodelistIds';

/**
 * Assumes needed codelists have been loaded
 */
export const useSchemasCodelists = (schemas: Schema[]): CodeListMap => {
  const codelistIds = useSchemaListCodelistIds(schemas);
  return useSchemaDataAccess().useCodelists(codelistIds);
};
